import React, {useEffect} from 'react';
import { useAuth0, withAuthenticationRequired  } from "@auth0/auth0-react";

import Map from "./Map/Map"

const App: React.FC = () => {
  console.log("App:React.FC");
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      console.log("App:React.FC useEffect[ isLoading, isAuthenticated, loginWithRedirect ] - Loading");
      return;
    }
    //console.log("App:React.FC useEffect[ isLoading, isAuthenticated, loginWithRedirect ] - loginWithRedirect");
    (async () => {
      await loginWithRedirect();
    })();
  }, [ isLoading, isAuthenticated, loginWithRedirect ]);

  return (
    <Map />
  );
}

export default withAuthenticationRequired(App);
